import { Accordion, type AccordionProps } from "@mui/material";
import type React from "react";
import { BasePaper } from "../base-paper";

export const BaseAccordion: React.FC<AccordionProps> = (props) => {
  return (
    <Accordion
      component={BasePaper}
      elevation={0}
      defaultExpanded
      sx={{
        borderRadius: "16px",
        "&:before": {
          display: "none",
        },
      }}
      {...props}
    >
      {props.children}
    </Accordion>
  );
};
